import { ProjectRoleService } from '@app/auth/services/project-role.service';
import { UserService } from '@app/auth/services/user.service';
import { CodeRepoService } from '@app/modules/assets/services/code-repo.service';
import { DataTableService } from '@app/modules/assets/services/data-table.service';
import { FoundationModelService } from '@app/modules/assets/services/foundation-model.service';
import { GlobalFunctionService } from '@app/modules/assets/services/global-function.service';
import { PipelineService } from '@app/modules/assets/services/pipeline-builder.service';
import { PromptService } from '@app/modules/assets/services/prompt.service';
import { RagService } from '@app/modules/assets/services/rag.service';
import { ReportsService } from '@app/modules/assets/services/reports.service';
import { DeploymentService } from '@app/modules/management/services/deployment.service';
import { RiskAssessmentService } from '@app/modules/management/services/risk-assessment.service';
import { AnnotationQueueService } from '@app/modules/monitor/services/annotation-queue.service';
import { MonitoringService } from '@app/modules/monitor/services/monitoring.service';
import { FeedbackPortalService } from '@app/modules/testing/services/feedback-portal.service';
import { TestSessionService } from '@app/modules/testing/services/test-session.service';
import { OBJECTS } from '@app/shared/constants/shared.constant';
import { ApprovalWorkflowService } from '@app/shared/services/approval-workflow.service';
import { GroupService } from '@app/shared/services/group.service';
import { PlatformSettingService } from '@app/shared/services/platform-setting.service';

export const OBJECT_SERVICE_MAPPER = {
    [OBJECTS.DATA_TABLE]: DataTableService,
    [OBJECTS.GLOBAL_FUNCTION]: GlobalFunctionService,
    [OBJECTS.USER]: UserService,
    [OBJECTS.PROJECT_ROLE]: ProjectRoleService,
    [OBJECTS.GROUP]: GroupService,
    [OBJECTS.APPROVAL_WORKFLOW]: ApprovalWorkflowService,
    [OBJECTS.REPORT]: ReportsService,
    [OBJECTS.PLATFORM_SETTING]: PlatformSettingService,
    [OBJECTS.PROMPT]: PromptService,
    [OBJECTS.FOUNDATION_MODEL]: FoundationModelService,
    [OBJECTS.RAG]: RagService,
    [OBJECTS.PIPELINE]: PipelineService,
    [OBJECTS.CODE_REPO]: CodeRepoService,
    [OBJECTS.FEEDBACK_PORTAL]: FeedbackPortalService,
    [OBJECTS.TEST_SESSION]: TestSessionService,
    [OBJECTS.ANNOTATION_QUEUE]: AnnotationQueueService,
    [OBJECTS.MONITORING]: MonitoringService,
    [OBJECTS.RISK_ASSESSMENT]: RiskAssessmentService,
    [OBJECTS.DEPLOYMENT]: DeploymentService,
};
